import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BingMapService } from './bing-map.service';
import { IMapPin } from '@caslink/common-client/ng-app/bing-map/typings/models';
import { Subscription } from 'rxjs';
import { EventTypes } from '../../src/typings/models';
import { CommonBroadcastService } from '../common-broadcast/common-broadcast.service';


@Component({
    selector: 'cl-bing-map',
    template: ``,
    styleUrls: ['./bing-map.component.scss']
})
export class BingMapComponent implements OnInit, OnDestroy {
    public static $name: string = 'clBingMap';

    @Input() private pins: IMapPin[];
    @Input() private customBtn: any;

    pinsChangeSubscription: Subscription;

    constructor(
        private bingMapService: BingMapService,
        private commonBroadcastService: CommonBroadcastService,
    ) {
    }

    ngOnInit() {
        this.initialize();
        this.commonBroadcastService.on<IMapPin[]>(EventTypes.PinsUpdated)
            .subscribe(newPins => this.bingMapService.updatePins(newPins));
    }

    ngOnDestroy() {
        this.bingMapService.dispose();
    }

    private initialize(): void {
        const mapWrapper = document.getElementsByTagName('cl-bing-map')[0] as HTMLElement;
        this.bingMapService.init(
            mapWrapper,
            this.pins,
            this.customBtn
        );
    }
}
